<script>
const ICON_PATH = 'assets/sprite.svg';

export default {
  name: "Icon",
  props: {
    name: {
      type: String,
      required: true
    },
  },
  methods: {
    getIconName(){
      return (appBuild === 'prod' ? ICON_PATH : '__spritemap') + '#' + this.name;
    }
  }
}
</script>

<template>
  <svg class="icon">
    <use :href="getIconName()"/>
  </svg>
</template>

<style scoped lang="scss">
  .icon {
    display: block;
    width: 28px;
    height: 28px;
    stroke: #333;
  }
</style>